import type { Checkout } from "../user/checkouts/models/checkout";

export class GetActiveRecords {
  static readonly type = '[Active records] - Get active records';
}

export class RemoveActiveRecord {
  static readonly type = '[Active records] - Remove active record';

  constructor(public checkoutId: string) {}
}

export class SetActiveCheckout {
  static readonly type = '[Active records] - Set active checkout';

  constructor(public checkout: Checkout) {}
}